import { supabase } from '../supabaseClient';

// Static pages configuration
const staticPages = [
  { title: 'Home', path: '/', keywords: 'home semesta main' },
  { title: 'Who We Are', path: '/about/who-we-are', keywords: 'about mission vision' },
  { title: 'Our Brand', path: '/about/our-brand', keywords: 'brand logo identity' },
  { title: 'Our History', path: '/about/our-history', keywords: 'history timeline' },
  { title: 'Our Team', path: '/about/our-team', keywords: 'team board management' },
  { title: 'Membership', path: '/about/membership', keywords: 'membership' },
  { title: 'Our Services', path: '/services', keywords: 'services business' },
  { title: 'Subsidiary Companies', path: '/services/subsidiary', keywords: 'subsidiary companies' },
  { title: 'News Releases', path: '/media/news-releases', keywords: 'news media releases' },
  { title: 'Our Stories', path: '/media/our-stories', keywords: 'stories media' },
  { title: 'Governance', path: '/governance', keywords: 'governance policy' },
  { title: 'Career', path: '/career', keywords: 'career jobs' },
  { title: 'Contact Us', path: '/contact', keywords: 'contact address email phone' },
];

let cachedData = null;

export const fetchSearchData = async () => {
  if (cachedData) return cachedData;

  try {
    const [newsRes, storiesRes, servicesRes] = await Promise.all([
      supabase.from('newsfeed').select('id, title, description, category, date, link'),
      supabase.from('our_stories').select('id, title_en, title_ms, description_en, description_ms, date'),
      supabase.from('services').select('id, "title-en", "title-my", "description-en", "description-my"')
    ]);

    cachedData = {
      news: newsRes.data || [],
      stories: storiesRes.data || [],
      services: servicesRes.data || [],
      pages: staticPages
    };

    return cachedData;
  } catch (error) {
    console.error("Error fetching search data:", error);
    return { news: [], stories: [], services: [], pages: staticPages };
  }
};

export const searchContent = async (query, language = 'eng') => {
  if (!query || query.length < 2) return [];

  const data = await fetchSearchData();
  const lowerQuery = query.toLowerCase();

  const results = [];

  // Search Pages
  data.pages.forEach(page => {
    if (page.title.toLowerCase().includes(lowerQuery) || page.keywords.includes(lowerQuery)) {
      results.push({
        type: 'Page',
        title: page.title,
        description: '',
        link: page.path
      });
    }
  });

  // Search News
  data.news.forEach(item => {
    if (
      (item.title && item.title.toLowerCase().includes(lowerQuery)) ||
      (item.description && item.description.toLowerCase().includes(lowerQuery)) ||
      (item.category && item.category.toLowerCase().includes(lowerQuery))
    ) {
      results.push({
        type: 'News',
        title: item.title,
        description: item.description,
        link: item.link || '/media/news-releases'
      });
    }
  });

  // Search Stories
  data.stories.forEach(item => {
    const title = language === 'ms' ? (item.title_ms || item.title_en) : (item.title_en || item.title_ms);
    const desc = language === 'ms' ? (item.description_ms || item.description_en) : (item.description_en || item.description_ms);
    
    if (
      (title && title.toLowerCase().includes(lowerQuery)) ||
      (desc && desc.toLowerCase().includes(lowerQuery))
    ) {
      results.push({
        type: 'Story',
        title: title,
        description: desc,
        link: `/media/our-stories/details/${item.id}`
      });
    }
  });

  // Search Services
  data.services.forEach(item => {
    const title = language === 'ms' ? (item['title-my'] || item['title-en']) : (item['title-en'] || item['title-my']);
    const desc = language === 'ms' ? (item['description-my'] || item['description-en']) : (item['description-en'] || item['description-my']);
    
    if (
      (title && title.toLowerCase().includes(lowerQuery)) ||
      (desc && desc.toLowerCase().includes(lowerQuery))
    ) {
      results.push({
        type: 'Service',
        title: title,
        description: desc,
        link: `/services/details/${item.id}`
      });
    }
  });

  return results;
};
